module.exports = __webpack_public_path__ + "static/media/DanskeNarrow-Italic.04ceb6b3.eot";